<template>
  <v-card flat>
    <table style="width: 100%">
      <tr>
        <td>Full Name</td>
        <td class="font-weight-bold" colspan="3">
          {{ displayValue(onBehalfInfo.full_name) }}
        </td>
      </tr>
      <tr>
        <td>First Name</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.first_name) }}
        </td>
        <td>Last Name</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.last_name) }}
        </td>
      </tr>
      <tr>
        <td>DOB</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.dob) }}
        </td>
        <td>Gender</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.gender) }}
        </td>
      </tr>
      <tr>
        <td>ID Type</td>
        <td class="font-weight-bold">
          {{ lookupValue(onBehalfInfo.id_type, "value") }}
        </td>
        <td>ID Number</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.id_number) }}
        </td>
      </tr>
      <tr>
        <td>ID Issue Date</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.id_issue_date) }}
        </td>
        <td>ID Expiry Date</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.id_expiry_date) }}
        </td>
      </tr>
      <tr>
        <td>ID Issue Location</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.id_issue_location) }}
        </td>
        <td>Mobile Number</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.mobile) }}
        </td>
      </tr>
      <tr>
        <td>Address</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.address) }}
        </td>
        <td>City</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.city) }}
        </td>
      </tr>
      <tr>
        <td>Postal Code</td>
        <td class="font-weight-bold">
          {{ displayValue(onBehalfInfo.postal_code) }}
        </td>
        <td>Country</td>
        <td class="font-weight-bold">
          {{ lookupValue(onBehalfInfo.country, "name") }}
        </td>
      </tr>
      <tr>
        <td>Nationality</td>
        <td class="font-weight-bold">
          {{ lookupValue(onBehalfInfo.nationality, "nationality") }}
        </td>
        <td>Occupation</td>
        <td class="font-weight-bold">
          {{ lookupValue(onBehalfInfo.occupation, "value") }}
        </td>
      </tr>
    </table>
  </v-card>
</template>

<script>
export default {
  name: "OnBehalfInfo",
  props: {
    onBehalfInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    displayValue(value) {
      return value === null || value === undefined || value === ""
        ? "-"
        : value;
    },
    lookupValue(value, preferredKey) {
      if (value && typeof value === "object") {
        return this.displayValue(
          value[preferredKey] || value.value || value.name || value.nationality,
        );
      }

      return this.displayValue(value);
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
